import type { RouteRecordRaw } from 'vue-router'
import { dashboardRoutes } from '@modules/dashboard'
import { listingRequestRoutes } from '@modules/listingRequest'
import { propertyRoutes } from '@modules/property'
import { marketplaceRoutes } from '@modules/marketplace'
import { profileRoutes } from '@modules/profile'
import { supportRoutes } from '@modules/support'

// Authenticated routes mounted under the AppLayout shell.
//
// The dashboard is the post-login landing (where the UAE PASS flow routes on
// success, and where the guard sends already-authenticated guests).
//
// Routes gated behind auth set `meta: { requiresAuth: true }` (the router guard
// in `index.ts` enforces it).
export const privateRoutes: RouteRecordRaw[] = [
  ...dashboardRoutes,
  ...listingRequestRoutes,
  ...propertyRoutes,
  ...marketplaceRoutes,
  ...profileRoutes,
  ...supportRoutes,
]
